<template></template>

<script>
import CreatePostSidebar from "@/layout/main/components/navbar/components/CreatePostSidebar";
export default {
  components: {
    CreatePostSidebar,
  },
  data() {
    return {
      // openCreatePostSidebar: false,
      // openAddChannelSidebar: false,
    };
  },
  methods: {
    createPost() {
      // this.toggleCreatePostSidebar(true);
      this.$store.commit("UI/TOGGLE_POST_CREATE_SIDEBAR", true);
    },
    // toggleCreatePostSidebar(val = false) {
    //   this.openCreatePostSidebar = val;
    // },
    handleCreateChanel() {
      // console.log("Hello")
      this.$store.commit("UI/TOGGLE_CHANNEL_CREATE_SIDEBAR", true);
    },
  },
};
</script>
